import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    defaultMessage: 'Contact Sales',
    id: 'U4byRi',
    description: 'Title of the modal showing sales contact form',
  },
  secondaryTitle: {
    defaultMessage: 'Receive a Call from an Expert',
    id: 'yoCjx+',
    description: 'Secondary title for the sales contact modal',
  },
  description: {
    defaultMessage:
      'Talk to one of our experts to understand your personalized savings recommendations and learn how we can help reduce your shipping costs.',
    id: '7DN+Jh',
    description: 'Description for the contact sales modal',
  },
  name: {
    defaultMessage: 'Name',
    id: 'h3Vf5E',
    description: 'Label for name input',
  },
  nameRequired: {
    defaultMessage: 'Name is required.',
    id: 'm1uvHT',
    description: 'Error message when name field is empty',
  },
  phoneNumber: {
    defaultMessage: 'Phone Number',
    id: '3FIrvN',
    description: 'Label for phone number input',
  },
  email: {
    defaultMessage: 'Email',
    id: 'KC3rcq',
    description: 'Label for email input',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: '6l1lNQ',
    description: 'Button text for closing the contact sales modal',
  },
  saveButton: {
    defaultMessage: 'Contact Sales',
    id: '0IsJuM',
    description: 'Button text for CTA to contact sales',
  },
  phoneNumberRequired: {
    defaultMessage: 'Phone Number is required.',
    id: 'sVUhWT',
    description: 'Error message when phone number field is empty',
  },
  phoneNumberValidationError: {
    defaultMessage: 'Phone Number must be between 10 and 15 digits long.',
    id: 'P/Qcmp',
    description: 'Error message when phone number is too short or too long',
  },
  phoneNumberValidationCharError: {
    defaultMessage: 'Use numbers, spaces, parentheses, + and - symbols only.',
    id: 'A8PeqL',
    description: 'Error message when phone number uses invalid characters',
  },
  emailRequired: {
    defaultMessage: 'Email is required.',
    id: '1SCx51',
    description: 'Error message when email field is empty',
  },
  emailValidationError: {
    defaultMessage: 'Please enter a valid email address.',
    id: '9jippB',
    description: 'Error message when email format is invalid',
  },
  phoneError: {
    defaultMessage: 'Phone number contains invalid characters',
    id: 'IpOais',
    description: 'Error message when phone number has bad characters',
  },
});
